import isEmpty from 'is-empty';
import validator from 'validator';

const kycValidateInputPersonal = (data) => {
  const errors = {};
  if (data.nationality === '' || !data.nationality || data.nationality.trim().length === 0 || data.nationality === 'Nationality') {
    errors.nationality = 'Kindly choose a nationality';
  }
  if (data.employmentStatus === '' || !data.employmentStatus || data.employmentStatus.trim().length === 0 || data.employmentStatus === 'Employment Status') {
    errors.employmentStatus = 'Kindly select an employment status';
  }
  if (data.stateOfOrigin === '' || !data.stateOfOrigin || data.stateOfOrigin.trim().length === 0 || data.stateOfOrigin === 'state') {
    errors.stateOfOrigin = 'Kindly select a state';
  }
  if (data.localGovernmentArea === '' || !data.localGovernmentArea || data.localGovernmentArea.trim().length === 0) {
    errors.localGovernmentArea = 'This field is required.';
  }
  if (data.gender === '' || !data.gender || data.gender.trim().length === 0) {
    errors.gender = 'This field is required.';
  }
  if (data.maritalStatus === '' || !data.maritalStatus || data.maritalStatus.trim().length === 0) {
    errors.maritalStatus = 'This field is required.';
  }
  if (data.mothersMaidenName === '' || !data.mothersMaidenName || data.mothersMaidenName.trim().length === 0) {
    errors.mothersMaidenName = 'This field is required.';
  }
  if (data.mothersMaidenName.trim().length < 2) {
    errors.mothersMaidenName = 'Name must be greater than 2 characters.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

const kycValidateInputAddress = (data) => {
  const errors = {};
  if (data.residentialAddress === '' || !data.residentialAddress || data.residentialAddress.trim().length === 0) {
    errors.residentialAddress = 'This field is required.';
  }
  if (data.contactAddress === '' || !data.contactAddress || data.contactAddress.trim().length === 0) {
    errors.contactAddress = 'This field is required.';
  }
  if (data.countryOfResidence === '' || !data.countryOfResidence || data.countryOfResidence.trim().length === 0) {
    errors.countryOfResidence = 'This field is required.';
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

// if (data.electronicTaxClearanceCertificate === '' || !data.electronicTaxClearanceCertificate || data.electronicTaxClearanceCertificate.trim().length === 0) {
//   errors.electronicTaxClearanceCertificate = 'This field is required.';
// }

const kycValidateInput = (data) => {
  const errors = {};
  const emailOfNextOfKin = data.emailOfNextOfKin.trim().toLowerCase();

  if (data.firstName === '' || !data.firstName || data.firstName.trim().length === 0) {
    errors.firstName = 'This field is required.';
  }
  if (data.lastName === '' || !data.lastName || data.lastName.trim().length === 0) {
    errors.lastName = 'This field is required.';
  }
  if (emailOfNextOfKin === '' || !emailOfNextOfKin || emailOfNextOfKin.trim().length === 0) {
    errors.emailOfNextOfKin = 'This field is required.';
  }
  if (emailOfNextOfKin && !validator.isEmail(emailOfNextOfKin)) {
    errors.emailOfNextOfKin = 'Invalid Email Input.';
  }
  if (data.phoneNumberOfNextOfKin === '' || !data.phoneNumberOfNextOfKin || data.phoneNumberOfNextOfKin.trim().length === 0) {
    errors.phoneNumberOfNextOfKin = 'This field is required.';
  }
  if (data.phoneNumberOfNextOfKin.trim().length > 0 && data.phoneNumberOfNextOfKin.trim().length !== 11 && data.phoneNumberOfNextOfKin !== Number) {
    errors.phoneNumberOfNextOfKin = 'Phone number should be 11 digits';
  }
  if (data.addressOfNextOfKin === '' || !data.addressOfNextOfKin || data.addressOfNextOfKin.trim().length === 0) {
    errors.addressOfNextOfKin = 'This field is required.';
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
};


const kycUploadInput = (data) => {
  const errors = {};

  if (data.electronicTaxClearanceCertificate === '' || !data.electronicTaxClearanceCertificate || data.electronicTaxClearanceCertificate.trim().length === 0) {
    errors.electronicTaxClearanceCertificate = 'This field is required.';
  }
  if (data.meansOfIdentificationURL === '' || !data.meansOfIdentificationURL || data.meansOfIdentificationURL.trim().length === 0) {
    errors.meansOfIdentificationURL = 'This field is required.';
  }
  if (data.signatureURL === '' || !data.signatureURL || data.signatureURL.trim().length === 0) {
    errors.signatureURL = 'This field is required.';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  }
}

export {
  kycValidateInput,
  kycValidateInputAddress,
  kycValidateInputPersonal,
  kycUploadInput
};
